(function () {
  'use strict';

  var MOBILE_MEDIA_QUERY = '(max-width: 749px)';

  // Content starts sliding in before the frame's width/height transition (1.6s
  // in the CSS) has fully settled, so the two motions overlap instead of
  // running strictly one-after-the-other.
  var CONTENT_REVEAL_DELAY_MS = 1000;
  // Must match .secondary-hero__content's transition duration.
  var CONTENT_SLIDE_MS = 1300;
  var DEFAULT_CROSSFADE_INTERVAL_MS = 3000;

  function startCrossfade(root) {
    var images = root.querySelectorAll('[data-secondary-hero-image]');
    if (images.length < 2) return;

    var seconds = parseFloat(root.dataset.secondaryHeroCrossfade);
    var intervalMs = seconds > 0 ? seconds * 1000 : DEFAULT_CROSSFADE_INTERVAL_MS;

    var activeIndex = 0;
    window.setInterval(function () {
      images[activeIndex].classList.remove('is-active');
      activeIndex = (activeIndex + 1) % images.length;
      images[activeIndex].classList.add('is-active');
    }, intervalMs);
  }

  function initDesktop(root, frame, reduceMotion) {
    if (reduceMotion) {
      root.classList.add('is-condensed', 'is-visible');
      startCrossfade(root);
      return;
    }

    function start() {
      // Lock the frame's current rendered pixel size, force the browser to commit
      // that layout, then switch to the target size in the same tick. Reading
      // offsetHeight in between forces the reflow that makes the width/height
      // transition reliable (transitioning straight from an aspect-ratio-derived
      // size doesn't animate consistently across browsers). Same technique as
      // Immersive Hero's main card, needed here because the aspect ratio itself
      // changes (1440:912 full-screen crop down to the 1390:747 resting shape).
      var rect = frame.getBoundingClientRect();
      frame.style.width = rect.width + 'px';
      frame.style.height = rect.height + 'px';
      void frame.offsetHeight;

      frame.style.removeProperty('width');
      frame.style.removeProperty('height');
      root.classList.add('is-condensed');

      window.setTimeout(function () {
        root.classList.add('is-visible');
      }, CONTENT_REVEAL_DELAY_MS);

      window.setTimeout(function () {
        startCrossfade(root);
      }, CONTENT_REVEAL_DELAY_MS + CONTENT_SLIDE_MS);
    }

    // Trigger as soon as the top of the section comes into view, rather than
    // waiting for it to be substantially scrolled into view.
    if (typeof IntersectionObserver === 'undefined') {
      start();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          start();
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(root);
  }

  function initMobile(root, reduceMotion) {
    var slot = root.querySelector('[data-secondary-hero-reveal]');
    if (!slot) return;

    if (reduceMotion || typeof IntersectionObserver === 'undefined') {
      slot.classList.add('is-revealed');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(slot);
  }

  function initSecondaryHero(root) {
    if (root.dataset.shInit === 'true') return;
    root.dataset.shInit = 'true';

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (window.matchMedia(MOBILE_MEDIA_QUERY).matches) {
      initMobile(root, reduceMotion);
      return;
    }

    var frame = root.querySelector('[data-secondary-hero-frame]');
    if (!frame) return;

    initDesktop(root, frame, reduceMotion);
  }

  function boot() {
    document.querySelectorAll('[data-secondary-hero]').forEach(initSecondaryHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
